import angular from 'angular';
import { DatasourcesService } from '@/hybrid/administration/datasources/datasources.service';

export default angular.module('Sq.Administration.Datasources', []).service('sqDatasourcesService', DatasourcesService);
